export enum AdditionalTimeApprovalStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export const ADDITIONAL_TIME_APPROVAL_STATUS: any = {
  [AdditionalTimeApprovalStatus.Pending]: 'pending',
  [AdditionalTimeApprovalStatus.Approved]: 'approved',
  [AdditionalTimeApprovalStatus.Rejected]: 'rejected',
};
